import messages from "./messages.i18n";
import * as yup from "yup";
import { useIntl } from "react-intl";
export const SpaceSettingsFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        unit: yup.string().required(intl.formatMessage(messages.updateFormAmenityLabelRequired)),
    });
};
export const SpaceSettingsFormInitialValue = {
    unit: "",
};
export const getSpaceSettingsFormFields = () => {
    const intl = useIntl();
    return {
        amenityName: [
            {
                id: "unit",
                label: intl.formatMessage(messages.updateFormAmenityLabel),
                placeholder: intl.formatMessage(messages.updateFormAmenityLabel),
                columns: 12,
                fullWidth: true,
                required: true,
            },
        ],
    };
};
